/**
 * Header Component
 * Redux connected
 * 
 * Can show or not show the title bar, driven by props.title
 * 
 * @prop {String} title
 */

import React from 'react';

const Footer = (props) => {

    return (
        <div className='slc-page-footer__image' />
    );

}

export default Footer;